import { CarrierType, RailVisitResponseDto, VesselVisitDto } from '@planning/app/api'
import { FieldStore, ISubFormStore } from '@tom-ui/utils'
import { action, makeObservable, observable } from 'mobx'
import { ActionChoice } from '../OutboundSubForm/OutboundSubFormStore'

export class InboundSubFormStore implements ISubFormStore<any> {
  carrierVisit: FieldStore<VesselVisitDto | RailVisitResponseDto | null | undefined>
  carrierType: FieldStore<CarrierType | null | undefined>
  origin: FieldStore<string | null | undefined>
  portOfLoading: FieldStore<string | null | undefined>
  approvalForDischarge: FieldStore<boolean | null | undefined>

  carrierTypeChoice: ActionChoice = 'keep'
  visitChoice: ActionChoice = 'keep'

  constructor() {
    this.carrierVisit = new FieldStore<VesselVisitDto | RailVisitResponseDto | null | undefined>(
      undefined,
    )
    this.carrierType = new FieldStore<CarrierType | null | undefined>(undefined)
    this.origin = new FieldStore<string | null | undefined>(undefined)
    this.portOfLoading = new FieldStore<string | null | undefined>(undefined)
    this.approvalForDischarge = new FieldStore<boolean | null | undefined>(undefined)

    makeObservable(this, {
      visitChoice: observable,
      carrierTypeChoice: observable,
      setCarrierTypeChoice: action,
      setVisitChoice: action,
    })
  }

  setCarrierTypeChoice = (choice: ActionChoice) => {
    this.carrierTypeChoice = choice
  }

  setVisitChoice = (choice: ActionChoice) => {
    this.visitChoice = choice

    if (choice === 'edit') {
      this.setCarrierTypeChoice('edit')
    }

    if (choice === 'keep') {
      this.setCarrierTypeChoice('keep')
    }
  }

  validate = () => {
    let isFormValid = true
    const requiredError = 'Field is required'

    if (this.carrierTypeChoice === 'edit' && !this.carrierType.value) {
      this.carrierType.setError(requiredError)
      isFormValid = false
    } else {
      this.carrierType.setError(undefined)
    }

    const requiresVisit =
      !this.carrierType.value ||
      (this.carrierType.value !== CarrierType.Universal &&
        this.carrierType.value !== CarrierType.Truck)

    if (this.visitChoice === 'edit' && requiresVisit) {
      if (!this.carrierVisit.value && !this.carrierVisit.error) {
        this.carrierVisit.setError(requiredError)
        isFormValid = false
      }
    }

    if (this.carrierVisit.error) {
      isFormValid = false
    }

    return isFormValid
  }

  get data() {
    return {
      carrierVisit: this.carrierVisit.data,
      origin: this.origin.data,
      portOfLoading: this.portOfLoading.data,
      carrierType: this.carrierType.data,
      approvalForDischarge: this.approvalForDischarge.data,
    }
  }
}
